import { render, staticRenderFns } from "./SamlLoginForAzure.vue?vue&type=template&id=516aa1d0&scoped=true"
import script from "./SamlLoginForAzure.vue?vue&type=script&lang=js"
export * from "./SamlLoginForAzure.vue?vue&type=script&lang=js"
import style0 from "./SamlLoginForAzure.vue?vue&type=style&index=0&id=516aa1d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516aa1d0",
  null
  
)

export default component.exports